import axios from "src/lib/axios";
import { LicenseDetails } from "./Types";

const API_URLS = {
  GET_LICENSE_DETAILS: `/License/GetLicenseDataForConfig`,
  INSERT_UPDATE_LICENSE: `/License/InsertUpdateLicenseDataForAppKey`
};

export const GetLicenseDetails = async (appKey: string) => {
  try {
    const response = await axios.get<LicenseDetails>(API_URLS.GET_LICENSE_DETAILS, {
        params: {
            appKey
        }
    });
    return response?.data  || null;
  } catch {
    return null;
  }
};

export const InsertUpdateLicenseForAppKey = async (file: File, appKey: string) => {
  try {
    const fileData = await file.text();

    const payload = {
      appKey,
      fileData,
    };

    const response = await axios.post(API_URLS.INSERT_UPDATE_LICENSE, payload);

    return response?.data?.isSuccess || false;
  } catch (error) {
    console.error("Upload error:", error);
    return false;
  }
};

